import { ColumnDef } from "@arelia-components/ui-atoms/data-grid";

export const API_ROUTE = '/api/earnings/tips';
export const columnConfig: ColumnDef[] = [{
  field: 'date',
  headerName: 'Date',
  editable: true,
  width: '25%',
  type: "date"
}, {
  field: 'name',
  headerName: 'Details',
  editable: true,
  width: '45%',
}, {
  field: 'amount',
  headerName: 'Tips',
  editable: true,
  width: '25%',
}];
